import React, { useEffect } from "react";
import { Flex, Spin, Tag, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { GetConsumeGroup } from "../redux/consumeThunk";
import { setSelectedGroup } from "../redux/consumeSlice";

const ConsFilterGroup = () => {
    const groups = useSelector(state => state.consumeState.groups);
    const selectedTags = useSelector(state => state.consumeState.selectedGroup);
    const loadingGroup = useSelector(state => state.consumeState.loadingGroup);
    const dispatch = useDispatch();
    const { Text } = Typography;

    useEffect(() => {

        const getGroupAction = GetConsumeGroup();
        dispatch(getGroupAction).unwrap().then((resp) => {     
        });
    },[]);

    const changeTag = (tag, checked) => {
        const nextSelectedTags = checked
        ? [...selectedTags, tag]
        : selectedTags.filter((t) => t !== tag);

        const setTagsAction =  setSelectedGroup(nextSelectedTags);
        dispatch(setTagsAction);     
    }

    return (
        <Flex vertical style={{gap:10,maxHeight:'fit-content',width:'98%'}}>
            <Text style={{fontSize:'1.2rem', fontWeight:500}}>Equipment Group</Text>
                <Flex style={{flex:1, flexWrap:"wrap", gap:8, width:'98%'}}>
                {
                    groups.map((g)=>{
                    return  (
                        <Tag.CheckableTag
                            checked={selectedTags.includes(g.MatGroup)}
                            onChange={(checked)=>changeTag(g.MatGroup,checked)}
                            style={{border: '1px solid #E5E7EB', background: selectedTags.includes(g.MatGroup)?'#3f076c':'rgba(255,255,255,0.9)', fontSize:13, borderRadius:20, marginTop:7,paddingTop:8,paddingBottom:8,paddingLeft:15,paddingRight:15,fontWeight:500}}                        
                        >
                            {g.MatGroup}
                        </Tag.CheckableTag>
                    )
                    })
                }
                </Flex>
        </Flex>
    )
}

export default ConsFilterGroup;